
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.87 16.5a.75.75 0 0 0 .53-1.28L11.18 12l3.22-3.22a.75.75 0 1 0-1.06-1.06L9.06 12l4.28 4.28a.747.747 0 0 0 .53.22Z"}})])
          )
        }
      }
    